export enum TABLE_CONSTANTS {
  minBuyIn = 0.5,
}
